import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { Box } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const checkBoxItems = [
    {
        label: "Utilization% is not in Range of India",
        checked: true,
    },
    {
        label: "Head count for France is matching with BOB reference",
    },
    {
        label: "Input beyond range HC, France!",
    },
];

const Product = () => {
    return (
        <div className="products">

            {checkBoxItems.map((item, index) => (
                <Box className="productInfo" key={index}>
                    <InfoOutlinedIcon className="InfoIcon" />
                    <FormControlLabel
                        className="productText"
                        value={item.label}
                        control={<Checkbox defaultChecked={item.checked} />}
                        label={item.label}
                        labelPlacement="start"
                    />
                </Box>
            ))}
        </div>
    );
};

export default Product;
